<template>
  <DxPopup
    :visible="value"
    :drag-enabled="false"
    :close-on-outside-click="true"
    :show-close-button="true"
    :show-title="true"
    :title="$t('VisibleFields')"
    width="90vw"
    height="auto"
    container=".dx-viewport"
    :wrapper-attr="{ class: 'popup-selectable-fields' }"
    @showing="syncLocalVisibility"
    @hiding="onCancel"
  >
    <div
      class="fields-popup-content"
      data-tour-id="samples-register-visible-fields-popup"
    >
        <div
          class="fields-popup-list"
          data-tour-id="samples-register-visible-fields-list"
          @wheel.prevent="onFieldsListWheel"
        >
        <template v-for="(item, index) in visibleFieldOptions">
          <div
            v-if="
              index === 0 ||
              item.section !== visibleFieldOptions[index - 1].section
            "
            class="fields-popup-section-header"
            :key="`section-${item.section}-${index}`"
          >
            {{ $t(item.section) }}
          </div>

          <div class="fields-popup-item" :key="`item-${item.key}`">
            <DxCheckBox
              :value="
                item.fixed ? true : Boolean(localVisibility[item.key])
              "
              :text="$t(item.labelKey)"
              :read-only="Boolean(item.fixed)"
              :element-attr="{
                class: item.fixed
                  ? 'fields-popup-checkbox fields-popup-checkbox--fixed'
                  : 'fields-popup-checkbox',
              }"
              @value-changed="(e) => onFieldToggle(item.key, e.value)"
            />
          </div>
        </template>
      </div>
      <div
        class="toolbar toolbar-bottom no-hairline"
        style="min-height: 80px"
      >
        <div class="toolbar-inner justify-content-flex-end">
          <f7-button
            class="button-large button-outline color-gray"
            style="width: 135px"
            fill
            outline
            type="default"
            styling-mode="contained"
            name="Cancelar"
            @click="onCancel"
          >
            {{ $t('cancel') }}
          </f7-button>
          <f7-button
            class="botones-registrar color-green whiteFontColor margin-left button-primary"
            data-tour-id="samples-register-visible-fields-apply"
            style="width: 135px"
            fill
            outline
            type="default"
            name="Aplicar"
            styling-mode="contained"
            @click="onApply"
          >
            {{ $t('apply') }}
          </f7-button>
        </div>
      </div>
    </div>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { DxCheckBox } from 'devextreme-vue/check-box';

export default {
  name: 'SelectablesFieldsPopup',
  components: {
    DxPopup,
    DxCheckBox,
  },
  props: {
    value: { type: Boolean, default: false },
    fieldsVisibility: {
      type: Object,
      default: () => ({
        lote: false,
        SubTipoMuestra: false,
        cloroResidual: false,
        cma: false,
        Legislacion: false,
        automaticSamplingPoint: false,
        farmPoint: false,
        plotPoint: false,
        samplingPointCoordinate: false,
        lmr: false,
        trazaCultivo: false,
        CultivoOrganico: false,
        Observaciones: false,
        inSituPh: false,
        inSituTemperatura: false,
        inSituConductividadElectrica: false,
        inSituOxigenoDisuelto: false,
        inSituCloroLibre: false,
        inSituTurbidez: false,
        inSituMonocloraminas: false,
        inSituSalinidad: false,
        inSituMaterialFlotante: false,
        // inSituTph: false,
        inSituPotencialRedox: false,
      }),
    },
  },
  data() {
    return {
      localVisibility: {},
      fieldOptions: [
        // — Sección Obligatorios —
        {
          key: 'mandatorySampleDescription',
          labelKey: 'samplesRegister.sampleDescription',
          section: 'sectionsPopUp.mandatory',
          fixed: true,
        },
        {
          key: 'mandatoryFamily',
          labelKey: 'samplesRegister.family',
          section: 'sectionsPopUp.mandatory',
          fixed: true,
        },
        {
          key: 'mandatorySampleType',
          labelKey: 'samplesRegister.sampleType',
          section: 'sectionsPopUp.mandatory',
          fixed: true,
        },
        {
          key: 'mandatoryAnalysisType',
          labelKey: 'samplesRegister.analysisType',
          section: 'sectionsPopUp.mandatory',
          fixed: true,
        },

        // — Sección Descriptivos —
        {
          key: 'SubTipoMuestra',
          labelKey: 'samplesRegister.sampleSubtype',
          section: 'sectionsPopUp.Descriptivos',
        },
        {
          key: 'lote',
          labelKey: 'samplesRegister.lot',
          section: 'sectionsPopUp.Descriptivos',
        },
        {
          key: 'automaticSamplingPoint',
          labelKey: 'samplesRegister.automaticSamplingPoint',
          section: 'sectionsPopUp.Descriptivos',
        },
        {
          key: 'farmPoint',
          labelKey: 'samplesRegister.farm',
          section: 'sectionsPopUp.Descriptivos',
        },
        {
          key: 'plotPoint',
          labelKey: 'samplesRegister.plot',
          section: 'sectionsPopUp.Descriptivos',
        },
        {
          key: 'samplingPointCoordinate',
          labelKey: 'samplesRegister.pointCoordinate',
          section: 'sectionsPopUp.Descriptivos',
        },
        {
          key: 'cma',
          labelKey: 'samplesRegister.cmaEnabled',
          section: 'sectionsPopUp.Descriptivos',
        },
        {
          key: 'Legislacion',
          labelKey: 'samplesRegister.legislation',
          section: 'sectionsPopUp.Descriptivos',
        },
        {
          key: 'lmr',
          labelKey: 'samplesRegister.lmrEnabled',
          section: 'sectionsPopUp.Descriptivos',
        },
        {
          key: 'trazaCultivo',
          labelKey: 'samplesRegister.trace',
          section: 'sectionsPopUp.Descriptivos',
        },
        {
          key: 'CultivoOrganico',
          labelKey: 'samplesRegister.organicFarming',
          section: 'sectionsPopUp.Descriptivos',
        },
        {
          key: 'Observaciones',
          labelKey: 'samplesRegister.sampleObservations',
          section: 'sectionsPopUp.Descriptivos',
        },

        // — Sección In Situ —
        {
          key: 'inSituPh',
          labelKey: 'samplesRegister.inSituFields.ph',
          section: 'sectionsPopUp.inSitu',
        },
        {
          key: 'inSituTemperatura',
          labelKey: 'samplesRegister.inSituFields.temperatura',
          section: 'sectionsPopUp.inSitu',
        },
        {
          key: 'inSituConductividadElectrica',
          labelKey:
            'samplesRegister.inSituFields.conductividadElectrica',
          section: 'sectionsPopUp.inSitu',
        },
        {
          key: 'inSituOxigenoDisuelto',
          labelKey: 'samplesRegister.inSituFields.oxigenoDisuelto',
          section: 'sectionsPopUp.inSitu',
        },
        {
          key: 'inSituCloroLibre',
          labelKey: 'samplesRegister.inSituFields.cloroLibre',
          section: 'sectionsPopUp.inSitu',
        },
        {
          key: 'cloroResidual',
          labelKey: 'samplesRegister.freeResidualChlorine',
          section: 'sectionsPopUp.inSitu',
        },
        {
          key: 'inSituTurbidez',
          labelKey: 'samplesRegister.inSituFields.turbidez',
          section: 'sectionsPopUp.inSitu',
        },
        {
          key: 'inSituMonocloraminas',
          labelKey: 'samplesRegister.inSituFields.monocloraminas',
          section: 'sectionsPopUp.inSitu',
        },
        {
          key: 'inSituSalinidad',
          labelKey: 'samplesRegister.inSituFields.salinidad',
          section: 'sectionsPopUp.inSitu',
        },
        {
          key: 'inSituMaterialFlotante',
          labelKey: 'samplesRegister.inSituFields.materialFlotante',
          section: 'sectionsPopUp.inSitu',
        },
        // {
        //   key: 'inSituTph',
        //   labelKey: 'samplesRegister.inSituFields.tph',
        //   section: 'sectionsPopUp.inSitu',
        // },
        {
          key: 'inSituPotencialRedox',
          labelKey: 'samplesRegister.inSituFields.potencialRedox',
          section: 'sectionsPopUp.inSitu',
        },
      ],
    };
  },
  watch: {
    fieldsVisibility: {
      handler() {
        if (!this.value) this.syncLocalVisibility();
      },
      deep: true,
    },
  },
  mounted() {
    this.syncLocalVisibility();
  },
  computed: {
    visibleFieldOptions() {
      return this.fieldOptions.filter(
        (item) => item.section !== 'sectionsPopUp.inSitu'
      );
    },
  },
  methods: {
    normalizeVisibility(visibility) {
      const normalized = {
        ...visibility,
      };

      if (normalized.farmPoint || normalized.plotPoint) {
        normalized.automaticSamplingPoint = true;
      }

      if (normalized.samplingPointCoordinate) {
        normalized.automaticSamplingPoint = true;
        normalized.farmPoint = true;
        normalized.plotPoint = true;
      }

      if (!normalized.automaticSamplingPoint) {
        normalized.farmPoint = false;
        normalized.plotPoint = false;
        normalized.samplingPointCoordinate = false;
      }

      if (!normalized.farmPoint || !normalized.plotPoint) {
        normalized.samplingPointCoordinate = false;
      }

      return normalized;
    },
    syncLocalVisibility() {
      this.localVisibility = this.normalizeVisibility(
        this.fieldsVisibility
      );
    },
    onFieldToggle(key, checked) {
      const nextVisibility = this.normalizeVisibility({
        ...this.localVisibility,
        [key]: checked === true,
      });
      this.localVisibility = nextVisibility;
    },
    onFieldsListWheel(event) {
      const list = event.currentTarget;
      if (!list) return;
      list.scrollTop += event.deltaY;
    },
    onCancel() {
      this.syncLocalVisibility();
      this.$emit('input', false);
      this.$emit('close');
    },
    onApply() {
      const payload = this.normalizeVisibility(this.localVisibility);
      this.$emit('apply', payload);
      this.$emit('update:fieldsVisibility', payload);
      this.$emit('input', false);
      this.$emit('close');
    },
  },
};
</script>

<style>
.popup-selectable-fields .dx-overlay-content.dx-popup-normal {
  max-width: 618px;
  max-height: 75vh;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 4px -1px rgba(87, 84, 95, 0.3),
    0 4px 4px rgba(87, 84, 95, 0.1);
}

.popup-selectable-fields .dx-popup-title {
  background: #fff;
  border-bottom: 0;
  padding: 20px 24px 8px;
}

.popup-selectable-fields .dx-popup-title .dx-toolbar-label {
  color: #04509f;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
}

.popup-selectable-fields .dx-popup-content {
  background: #fff;
  padding: 0 24px 24px;
}

.fields-popup-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: calc(75vh - 88px);
}

.fields-popup-list {
  border: 1px solid #d9e5f2;
  border-radius: 10px;
  padding: 8px 12px;
  background: #fff;
  max-height: calc(75vh - 170px);
  overflow-y: auto;
  min-height: 0;
}

.fields-popup-item {
  padding: 10px 2px;
  border-bottom: 1px solid #eef3f9;
}

.fields-popup-item:last-child {
  border-bottom: 0;
}

.fields-popup-item .dx-checkbox-text {
  color: #00346a;
  font-size: 13px;
}

.fields-popup-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 8px;
  flex-shrink: 0;
}

.fields-popup-btn {
  min-width: 124px;
  height: 40px;
}

.fields-popup-btn .dx-button-content {
  border-radius: 10px;
}

.fields-popup-btn--cancel .dx-button-content {
  color: #6b7280;
  border: 1px solid #9ca3af;
  background: #fff;
  font-weight: 500;
}

.fields-popup-btn--apply .dx-button-content {
  background: #04509f;
  color: #fff;
  font-weight: 600;
}

.fields-popup-btn--apply .dx-button-content:hover {
  background: #003f80;
}

.fields-popup-section-header {
  color: #04509f;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 12px 2px 4px;
  border-bottom: 1px solid #d9e5f2;
  margin-bottom: 2px;
}

/* Eliminar el espacio extra en el primer encabezado */
.fields-popup-section-header:first-child {
  padding-top: 4px;
}
</style>
